<script>
import { PERMISSION_LEVEL_CONSTS, RESOURCES } from '@/utilities/appConsts'
export default {
  data() {
    return {
      permissionLevelConsts: PERMISSION_LEVEL_CONSTS,
      resources: RESOURCES,
    }
  },
  computed: {
    isEditPermissionInvestigate() {
      return this.hasResourcePermission({
        resource: this.resources.MAINTENANCE_REC_INVESTIGATION,
        permissionLevel: this.permissionLevelConsts.EDIT,
      })
    },
    isReadOnlyPermissionInvestigate() {
      return (
        !this.isEditPermissionInvestigate &&
        this.hasResourcePermission({
          resource: this.resources.MAINTENANCE_REC_INVESTIGATION,
          permissionLevel: this.permissionLevelConsts.READ,
        })
      )
    },
    isMxRecEditPermission() {
      return (
        !this.isEditPermissionInvestigate &&
        !this.isReadOnlyPermissionInvestigate &&
        this.hasResourcePermission({
          resource: this.resources.MAINTENANCE_REC,
          permissionLevel: this.permissionLevelConsts.EDIT,
        })
      )
    },
    isMxRecReadOnlyPermission() {
      return (
        !this.isMxRecEditPermission &&
        this.hasResourcePermission({
          resource: this.resources.MAINTENANCE_REC,
          permissionLevel: this.permissionLevelConsts.READ,
        })
      )
    },
    isEditPermissionFeatureInvestigation() {
      return this.hasResourcePermission({
        resource: this.resources.FEATURE_INVESTIGATION,
        permissionLevel: this.permissionLevelConsts.EDIT,
      })
    },
    isReadPermissionFeatureInvestigation() {
      return this.hasResourcePermission({
        resource: this.resources.FEATURE_INVESTIGATION,
        permissionLevel: this.permissionLevelConsts.READ,
      })
    },
    isReadPermissionUserTagging() {
      return this.hasResourcePermission({
        resource: this.resources.USER_TAGGING,
        permissionLevel: this.permissionLevelConsts.READ,
      })
    },
  },
}
</script>
